<template>
  <div>
    <panel title="Valores da Guia de Medidas">
      <form-group label="Nome da Guia de Medidas" :required="true" :error="getError('name')" :columns="4">
        <input class="form-input" type="text" v-model="sizeGrid.name">
      </form-group>
    </panel>

    <panel title="Tabela de Tamanhos">
      <table class="table">
        <thead>
          <tr>
            <th>Comprimento do Pé</th>
            <th>BR</th>
            <th>US</th>
            <th>EU</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="sizeGrid" v-for="(size, i) in sizeGrid.sizes">
            <td v-if="size.FOOT_LENGTH !== undefined">
              <div class="form-group-addon">
                <input v-model="size.FOOT_LENGTH" v-mask="'##.##'" type="text" class="form-input">
                <span class="form-addon">cm</span>
              </div>
            </td>
            <td v-if="size.BR_SIZE !== undefined">
              <div class="form-group-addon">
                <input v-model="size.BR_SIZE" type="text" v-mask="'##'" class="form-input">
                <span class="form-addon">BR</span>
              </div>
            </td>
            <td v-if="size.M_US_SIZE !== undefined">
              <div class="form-group-addon">
                <input v-model="size.M_US_SIZE" type="text" v-mask="'##'" class="form-input">
                <span class="form-addon">US</span>
              </div>
            </td>
            <td v-if="size.EU_SIZE !== undefined">
              <div class="form-group-addon">
                <input v-model="size.EU_SIZE" type="text" v-mask="'##'" class="form-input">
                <span class="form-addon">EU</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </panel>

    <panel>
      <button :disabled="saving" @click="save()" v-bind:class="{ 'is-loading': saving }" class="btn btn--success" type="submit">Salvar</button>
    </panel>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import GeneralCategory from '@/components/marketplace/mercadoLivre/sizeGrid/general/Category'
  import RadioButton from '@/components/template/RadioButton'
  import Loader from '@/components/template/Loader'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      saving: false,
      sizeGrid: null,
      sizeGridRows: [],
      errorMessages: [],
      attributesLabels: [],
      mainSizesOptions: []
    }),
    props: {
      identifier: {
        type: String,
        required: true
      }
    },
    async mounted () {
      api.mercadoLivre.getSizeGrid(this.identifier)
        .then((data) => {
          this.sizeGrid = data
          this.name = data.names.MLB
          this.sizeGrid.rows.forEach(row => {
            row.attributes.forEach(attribute => {
              this.attributesLabels.push(attribute.label)
            })
          })
          this.loadTechnicalSpecs()
        })
        .catch(() => {
        })
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors',
        'clearError',
        'getError',
        'getErrors'
      ]),
      addRow () {
      },
      validates (attribute, i) {
        var hasError = false

        if (attribute.min !== null) {
          if (parseFloat(this.sizeRows[i][attribute.id]) < attribute.min) {
            hasError = true
          }
        }

        if (attribute.max !== null) {
          if (parseFloat(this.sizeRows[i][attribute.id]) > attribute.max) {
            hasError = true
          }
        }

        if (hasError) {
          this.addError({
            property: attribute.id,
            productId: i,
            error: {
              message: 'errorSizeGridRange',
              value: 1
            }
          })
        } else {
          this.clearError({attribute: attribute.id, sizeRow: i})
        }
      },
      async loadTechnicalSpecs () {
        var genderValue = null
        this.sizeGrid.attributes.forEach(attribute => {
          if (attribute.id === 'GENDER') {
            attribute.values.forEach(value => {
              genderValue = {
                id: value.id,
                name: value.name
              }
            })
          }
        })

        let data = {
          domain: this.sizeGrid.domain_id,
          gender: genderValue
        }

        this.sizeAttributes = await api.mercadoLivre.getDomainTechnicalSpecs(data, this.sizeGrid.seller_id)

        this.mainSizesOptions = []
        this.mainSize = null
        this.sizeAttributes.forEach(attribute => {
          if (attribute.mainAttribute !== undefined && attribute.mainAttribute && attribute.id === 'mainSize') {
            this.mainSizesOptions = attribute.values
          }
        })
      },
      save () {
        this.clearErrors()

        this.saving = true

        if (this.name === null) {
          this.addError({
            property: `name`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        // todo merge
        var sizeGrid = this.sizeGrid

        api.mercadoLivre.updateSizeGrid(sizeGrid)
          .then(() => {
            notifier.success('Guia de Medidas atualizada com sucesso!', 'Sucesso')
            this.$router.push('/marketplace/mercadoLivre/sizegrids')
            this.saving = false
          })
          .catch(() => {
            notifier.error('Erro ao cadastrar a tabela de medidas, verifique as informações!', 'Erro')
            this.saving = false
          })
      },
      isLoader (status) {
        this.loading = status
      },
      async setSelectedCategory (selectedCategory) {
        try {
          const accountId = await api.mercadoLivre.getActiveAccountId()
          var infos = await api.mercadoLivre.getCategoryInfo(accountId, selectedCategory, 'SIZE_-_COLOR')
          infos.attributes.forEach(attribute => {
            if (attribute.id === 'GENDER') {
              this.genders = attribute.values
            }
          })
        } catch (e) { }

        this.category = selectedCategory
      },
      onChangeMainAttributes () {},
      removeSize (i) {
        this.sizeRows.splice(i, 1)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError',
        'getErrors'
      ])
    },
    watch: {
    },
    components: {
      PageTitle,
      Panel,
      FormGroup,
      Multiselect,
      GeneralCategory,
      RadioButton,
      Loader
    }
  }
</script>

<style scoped>
  div ul {
    padding: 0px;
  }
  .sizeRowItem {
    padding-top: 1.6pc;
  }
  .sizeRowItem .hrTitle {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3pc;
    text-align: center;
    position: relative;
    color: #b9b9b9;
  }
  .sizeRowItem .hrTitle span.hr {
    width: 9%;
    height: 1px;
    background-color: #d7d3d3;
    position: absolute;
    left: 39%;
    top: 9px;
  }
  .sizeRowItem .hrTitle span.hr.right {
    left: 52% !important;
  }
  ul.radio-inline {
    list-style: none;
  }
  .form-group-addon {
    display: inline-flex;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?702d30f1